import React from "react";
import {
  Card,
  Text,
  Group,
  Menu,
  Button,
  Grid,
  Box,
  Stack,
} from "@mantine/core";
import {
  IconChevronDown,
  IconClock,
  IconPlayerPlay,
  IconAdjustments,
  IconCircleCheck,
} from "@tabler/icons-react";
import { Client, OverviewCounts } from "api/client/getClientProfile";

export interface ClientDashboardProps {
  client: Client;
  overview: OverviewCounts;
}

export default function ClientDashboard(props: ClientDashboardProps) {
  const { client, overview } = props;
  console.log(overview, "overview");
  console.log(client?.name, "client?.name}");
  const timeRanges = [
    { value: "7", label: "Last 7 days" },
    { value: "30", label: "Last 30 days" },
    { value: "month", label: "This Month" },
  ];

  return (
    <Box mt={4} sx={{ marginBottom: "2px" }}>
      <Box>
        <Card style={{ marginBottom: "10px" }}>
          <Group position="apart" align="center" mb="md">
            <Group align="center" spacing="sm">
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #a855f7, #6366f1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text color="white" weight={700} size="lg">
                  {client?.name
                    ? client.name.trim().charAt(0).toUpperCase()
                    : ""}
                </Text>
              </Box>
              <div>
                <Text size="lg" weight={700}>
                  {client?.name}
                </Text>
                <Text size="sm" color="dimmed">
                  Client Dashboard
                </Text>
              </div>
            </Group>

            <Menu shadow="md">
              <Menu.Target>
                <Button
                  variant="outline"
                  disabled
                  rightIcon={<IconChevronDown size={16} />}
                >
                  Last 7 days
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                {timeRanges.map((range) => (
                  <Menu.Item key={range.value}>{range.label}</Menu.Item>
                ))}
              </Menu.Dropdown>
            </Menu>
          </Group>
        </Card>

        <Grid>
          <Grid.Col xs={12} md={6}>
            <Card mb="md" style={{ height: "30vh" }}>
              <Text weight={600} mb="sm">
                Client Information
              </Text>
              <Text size="sm" mb="xs">
                <span>Name :</span> {client?.name}
              </Text>
              <Text size="sm" mb="xs">
                <span>Email :</span> {client?.email}
              </Text>
              <Text size="sm">
                {" "}
                <span>Phone :</span> {client?.phone}
              </Text>
              <Text size="sm">
                {" "}
                <span>Address</span> {client?.address}
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Card mb="md" style={{ height: "30vh" }}>
              <Text weight={600} mb="sm">
                Quick Stats
              </Text>
              <Box>
                <Group position="apart">
                  <Text size="sm">Total Projects</Text>
                  <Text size="sm">{overview.totalProjects}</Text>
                </Group>
                <Group position="apart">
                  <Text size="sm">Total Tasks</Text>
                  <Text size="sm">{overview?.totalIssues}</Text>
                </Group>
                <Group position="apart">
                  <Text size="sm">Completion Rate</Text>
                  <Text size="sm" color="green">
                    {overview?.completionRate}
                  </Text>
                </Group>
                <Group position="apart">
                  <Text size="sm">Completed</Text>
                  <Text size="sm">{overview?.completedIssues}</Text>
                </Group>
                <Group position="apart">
                  <Text size="sm">Todo</Text>
                  <Text size="sm">{overview?.todoIssues}</Text>
                </Group>
                <Group position="apart">
                  <Text size="sm">in Review</Text>
                  <Text size="sm">{overview?.inReviewIssues}</Text>
                </Group>
                <Group position="apart">
                  <Text size="sm">in Progress</Text>
                  <Text size="sm">{overview?.inProgressIssues}</Text>
                </Group>
              </Box>
            </Card>
          </Grid.Col>
        </Grid>

        <Grid gutter="md" mb="md">
          <Grid.Col xs={12} md={6}>
            <Card
              radius="md"
              sx={{
                background: "linear-gradient(135deg, #3b82f6, #6366f1)",
                color: "white",
              }}
            >
              <Group position="apart" align="center">
                <div>
                  <Text size="lg" weight={600}>
                    To Do
                  </Text>
                  <Text size="xl" weight={700}>
                    {overview?.todoIssues}
                  </Text>
                </div>
                <IconClock size={32} />
              </Group>
            </Card>
          </Grid.Col>

          <Grid.Col xs={12} md={6}>
            <Card
              radius="md"
              p="lg"
              sx={{
                background: "linear-gradient(135deg, #f97316, #f59e0b)",
                color: "white",
              }}
            >
              <Group position="apart" align="center">
                <div>
                  <Text size="lg" weight={600}>
                    In Progress
                  </Text>
                  <Text weight={700}>{overview?.inProgressIssues}</Text>
                </div>
                <IconPlayerPlay size={24} />
              </Group>
            </Card>
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Card
              radius="md"
              p="lg"
              sx={{
                background: "linear-gradient(135deg, #8b5cf6, #ec4899)",
                color: "white",
              }}
            >
              <Group position="apart" align="center">
                <div>
                  <Text size="lg" weight={600}>
                    In Review
                  </Text>
                  <Text weight={700}>{overview.inReviewIssues}</Text>
                </div>
                <IconAdjustments size={24} />
              </Group>
            </Card>
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            <Card
              radius="md"
              p="lg"
              sx={{
                background: "linear-gradient(135deg, #22c55e, #16a34a)",
                color: "white",
              }}
            >
              <Group position="apart" align="center">
                <div>
                  <Text size="lg" weight={600}>
                    Completed
                  </Text>
                  <Text weight={700}>{overview?.completedIssues}</Text>
                </div>
                <IconCircleCheck size={24} />
              </Group>
            </Card>
          </Grid.Col>
        </Grid>
      </Box>
    </Box>
  );
}
